export function buildPaginationHref(asPath: string, page: number) {
  const [pathWithQuery = '', hash] = asPath.split('#');
  const [path = '', search = ''] = pathWithQuery.split('?');
  const searchParams = new URLSearchParams(search);

  if (page <= 1) {
    searchParams.delete('page');
  } else {
    searchParams.set('page', page.toString());
  }

  const queryString = searchParams.toString();

  return `${path}${queryString ? `?${queryString}` : ''}${hash ? `#${hash}` : ''}`;
}
